// extracted by mini-css-extract-plugin
export default {"container":"Landing_container__RfCbs","logoWrapper":"Landing_logoWrapper__uYIRr","logo":"Landing_logo__SJ-N5","title":"Landing_title__M2UoV","tagline":"Landing_tagline__IK9VY"};